<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15lBUZT/tc-custom/9781504034289.jpg?1734196264705" alt="This image is the cover for the book Martha, Eric, and George, The Martha Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Martha, Eric, and George, The Martha Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>After ten years, a successful painter returns to Paris and the son she left behind on her ex-lover’s doorstep, in Margery Sharp’s sparkling novel that features the artistic heroine of <i>Martha in Paris</i></b><br/><br/> After studying with <i>le maître</i> in Paris for a year, Martha returned to England to pursue her artistic destiny. Ten years later, she is an enormous success. But when she returns to Paris to attend an exhibition of her work, she must face some unfinished business she left behind: her ten-year-old son, George. Raised by his doting grandmother and his disinterested father, Eric, George attends his mother’s exhibition and Martha realizes she may well have met her match—a member of the opposite sex who will not let her go through life unencumbered.<br/>  <br/><i>Martha, Eric, and George</i> is a witty and poignant novel about the indelible bond between mother and child, and the creative spark that can light up a life.<br/>  <br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margery  Sharp
      </h2>
      
      <p class="authorDescription body article">Margery Sharp is renowned for her sparkling wit and insight into human nature, both of which are liberally displayed in her critically acclaimed social comedies of class and manners. Born in Yorkshire, England, Sharp wrote pieces for <I>Punch</I> magazine after attending college and art school. In 1930, she published her first novel, <I>Rhododendron Pie</I>, and in 1938, married Maj. Geoffrey Castle. Sharp wrote twenty-six novels, three of which&mdash;<I>Britannia Mews</I>,<I> Cluny Brown</I>, and <I>The Nutmeg Tree</I>&mdash;were made into feature films, and fourteen children&rsquo;s books, including <I>The Rescuers</I>, which was adapted into two Disney animated films.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9eabf82e